type LoaderProps = {
    /** Text announced to screen readers (and shown if `showMessage` is set). */
    message?: string;
    /** Also show the message as visible text under the spinner. */
    showMessage?: boolean;
    /** Center in the full viewport height, for whole-page/route loading states. */
    fullPage?: boolean;
    className?: string;
};

/**
 * Global loading spinner. Centers itself in whatever container it's placed
 * in; pass `fullPage` to center in the full viewport instead (e.g. while a
 * route or the whole app is still bootstrapping).
 */
export const Loader = ({
    message = "Loading...",
    showMessage = false,
    fullPage = false,
    className = "",
}: LoaderProps) => {
    return (
        <div
            className={[
                "appLoader",
                fullPage && "appLoader--fullPage",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
        >
            <div className="appLoaderSpinner spinner-border" role="status">
                <span className="visually-hidden">{message}</span>
            </div>
            {showMessage && <div className="appLoaderMessage">{message}</div>}
        </div>
    );
};
